export const PAGE_NOT_FOUND = 'PAGE_NOT_FOUND'
export const ONE_MOMENT = 'ONE_MOMENT'
export const PROCESSING_SECURE_TRANSACTION = 'PROCESSING_SECURE_TRANSACTION'
export const AN_ERROR_OCCURRED = 'AN_ERROR_OCCURRED'
export const PLEASE_CONTACT_OR_TRY_AGAIN = 'PLEASE_CONTACT_OR_TRY_AGAIN'
export const UNVERIFIED_AUTHENTICATION = 'UNVERIFIED_AUTHENTICATION'
export const AUTHENTICATION_FAILED = 'AUTHENTICATION_FAILED'
export const TRY_AGAIN = 'TRY_AGAIN'
